export enum EAirSearchPermissions {
    IQBA_SEARCHFORM_SECTOR = 'iqba.searchForm.sector',
    IQBA_SEARCHFORM_KEYWORD = 'iqba.searchForm.keyword',
    IQBA_SEARCHFORM_QUANTITY = 'iqba.searchForm.quantity',
    IQBA_SEARCHFORM_HOST = 'iqba.searchForm.host',
    IQBA_SEARCHFORM_PLUSORMINUS = 'iqba.searchForm.plusOrMinus',
    IQBA_SEARCHFORM_ADDITIONAL_CARRIER = 'iqba.searchForm.additional.carrier',
    IQBA_SEARCHFORM_ADDITIONAL_PRICE = 'iqba.searchForm.additional.price',
    IQBA_SEARCHFORM_CABIN_USE = 'iqba.searchForm.cabin.use',
    IQBA_SEARCHFORM_MAXVIAS_USE = 'iqba.searchForm.maxvias.use',
    IQBA_SEARCHFORM_TIME_SLOTS_USE = 'iqba.searchForm.time.slots.use',
}